/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint dot-notation: 0 */
/* eslint no-param-reassign: 0 */
/* eslint max-len: 0 */

// ------------------------------ Joystick ------------------------------------

const JOYSTICK_INCLUDE_KEY = 'EDUPLUG_joystick';
const JOYSTICK_INCLUDE = '#include <EduplugPowerJoystick.h>\n';

// actualizar() tiene que correr en cada iteración del loop para refrescar el
// estado del mando.
const JOYSTICK_LOOP_KEY = 'EDUPLUG_joystick_link';
const JOYSTICK_LOOP = 'EduplugPowerJoystick.actualizar();\n';

// El link abre el puerto serie en setup(): fix de producción (0c103283e, PR #98)
// que se hizo solo en el generador legacy. Mismo string y misma clave que allá
// (el `\n` final incluido), porque finish() replica el armado del legacy.
const JOYSTICK_SETUP = 'Serial.begin(9600);\n';

export const EDUPLUG_joystick_link = (block, generator) => {
  const opt = block.getFieldValue('STAT');
  generator.definitions_[JOYSTICK_INCLUDE_KEY] = JOYSTICK_INCLUDE;
  generator.setups_[JOYSTICK_INCLUDE_KEY] = JOYSTICK_SETUP;
  return `EduplugPowerJoystick.${opt}();\n`;
};

export const EDUPLUG_joystick_connected = (block, generator) => {
  generator.definitions_[JOYSTICK_INCLUDE_KEY] = JOYSTICK_INCLUDE;
  generator.loop_[JOYSTICK_LOOP_KEY] = JOYSTICK_LOOP;
  return ['EduplugPowerJoystick.estaConectado()', generator.ORDER_ATOMIC];
};

export const EDUPLUG_joystick_read = (block, generator) => {
  const stick = block.getFieldValue('STICK') || 'derecho';
  const axis = block.getFieldValue('AXIS') || 'X';
  generator.definitions_[JOYSTICK_INCLUDE_KEY] = JOYSTICK_INCLUDE;
  return [`EduplugPowerJoystick.${stick}${axis}()`, generator.ORDER_ATOMIC];
};

export const EDUPLUG_joystick_button_read = (block, generator) => {
  // Default 'A' aunque el dropdown usa botonA/botonB/...: quirk del legacy preservado.
  const button = block.getFieldValue('BUTTON') || 'A';
  generator.definitions_[JOYSTICK_INCLUDE_KEY] = JOYSTICK_INCLUDE;
  return [`EduplugPowerJoystick.${button}()`, generator.ORDER_ATOMIC];
};

// ------------------------------ Motor / Servo -------------------------------

const MOTORS_INCLUDE_KEY = 'motors';
const MOTORS_INCLUDE = '#include <EduplugPowerMotores.h>\n';
const MOTORS_SETUP_KEY = 'setup_motors';
const MOTORS_SETUP = 'EduplugPowerMotores.iniciar();\n';

export const EDUPLUG_motor_doble = (block, generator) => {
  generator.definitions_[MOTORS_INCLUDE_KEY] = MOTORS_INCLUDE;
  generator.setups_[MOTORS_SETUP_KEY] = MOTORS_SETUP;
  switch (block.getFieldValue('DIR')) {
    case '3': return 'EduplugPowerMotores.avanzar(255);\n';
    case '4': return 'EduplugPowerMotores.retroceder(255);\n';
    case '5': return 'EduplugPowerMotores.girarDerecha(255);\n';
    case '6': return 'EduplugPowerMotores.girarIzquierda(255);\n';
    case '7': return 'EduplugPowerMotores.frenar();\n';
    default: return '';
  }
};

export const EDUPLUG_motor_doble_pwm = (block, generator) => {
  const PWM = generator.valueToCode(block, 'PWM', generator.ORDER_ATOMIC) || '';
  generator.definitions_[MOTORS_INCLUDE_KEY] = MOTORS_INCLUDE;
  generator.setups_[MOTORS_SETUP_KEY] = MOTORS_SETUP;
  switch (block.getFieldValue('DIR')) {
    case '3': return `EduplugPowerMotores.avanzar(${PWM});\n`;
    case '4': return `EduplugPowerMotores.retroceder(${PWM});\n`;
    case '5': return `EduplugPowerMotores.girarDerecha(${PWM});\n`;
    case '6': return `EduplugPowerMotores.girarIzquierda(${PWM});\n`;
    case '7': return 'EduplugPowerMotores.frenar();\n';
    default: return '';
  }
};

// API de la librería: motorDerecho/motorIzquierdo(dir, vel), dir 1 = adelante, 0 = atrás.
export const EDUPLUG_motor_single = (block, generator) => {
  const npin = block.getFieldValue('NPIN');
  generator.definitions_[MOTORS_INCLUDE_KEY] = MOTORS_INCLUDE;
  generator.setups_[MOTORS_SETUP_KEY] = MOTORS_SETUP;
  switch (block.getFieldValue('DIR')) {
    case '3': return `EduplugPowerMotores.motor${npin}(1,255);\n`;
    case '4': return `EduplugPowerMotores.motor${npin}(0,255);\n`;
    default: return '';
  }
};

export const EDUPLUG_motor_single_speed = (block, generator) => {
  const PWM = generator.valueToCode(block, 'PWM', generator.ORDER_ATOMIC) || '';
  const npin = block.getFieldValue('NPIN');
  generator.definitions_[MOTORS_INCLUDE_KEY] = MOTORS_INCLUDE;
  generator.setups_[MOTORS_SETUP_KEY] = MOTORS_SETUP;
  switch (block.getFieldValue('DIR')) {
    case '3': return `EduplugPowerMotores.motor${npin}(1,${PWM});\n`;
    case '4': return `EduplugPowerMotores.motor${npin}(0,${PWM});\n`;
    default: return '';
  }
};

export const EDUPLUG_servo_move = (block, generator) => {
  const angle = generator.valueToCode(block, 'angulo', generator.ORDER_ATOMIC);
  const npin = block.getFieldValue('NPIN') || '';
  generator.definitions_['EDUPLUG_servo_move'] = MOTORS_INCLUDE;
  generator.setups_['EDUPLUG_servo_move'] = MOTORS_SETUP;
  return `EduplugPowerMotores.servo${npin}(${angle});\n`;
};
